import { apiFetch } from '../../../lib/api/client.js';
import type { FeedRow } from '../types.js';

export function fetchRecentFeed(opts: { limit?: number; mine?: boolean } = {}): Promise<{ rows: FeedRow[] }> {
  const qs = new URLSearchParams();
  if (opts.limit) qs.set('limit', String(opts.limit));
  if (opts.mine) qs.set('mine', '1');
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  return apiFetch<{ rows: FeedRow[] }>(`/originals/feed/recent${suffix}`);
}
